// Module
var code = "<div class=\"flat-list\"> <div class=\"prev-button-container\"><button>Prev</button></div> <div class=\"next-button-container\"><button>Next</button></div> <div class=\"flat-list-container\"></div> </div>";
// Exports
export default code;